import React, { useEffect, useState } from "react";
import { Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import apiClient from "../../utils/api";
import "./styles.css";

const ProductsOfTheMonth = () => {
  const [POMData, setPOMData] = useState([]);

  const fetchPOMData = async () => {
    try {
      const res = await apiClient.post(`get/product_of_month.php`, {});
      setPOMData(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setPOMData([]);
    }
  };

  useEffect(() => {
    fetchPOMData();
  }, []);

  // Function to truncate description
  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + " (more...)"
      : text;
  };
 

  return (
    <>
      {POMData.length > 0 ? (
        POMData.map((d, i) => (
          <Col key={i} xs={12} sm={6} md={4} className="p-3">
            <Card
              className="shadow-lg border-0 rounded-4 text-center"
              // fixed height
            >
              {/* Top Image */}
              <Card.Img
                variant="top"
                src={d.img1}
                alt={d.product_name}
                className="rounded-top-4 month-card-2"
              />

              {/* Card Body */}
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title className="content-name">
                    {d.product_name || "WEB DEVELOPER"}
                  </Card.Title>
                  <Card.Text
                    className="text-muted small px-2 new-desc-text"
                    style={{ textAlign: "justify" }}
                  >
                    {truncateText(
                      d.description ||
                        "We are looking for passionate developers to join our creative team. Build modern apps and grow with us!",
                      150
                    )}
                  </Card.Text>
                </div>

                {/* Button */}
                <div className="d-flex justify-content-center">
                  <Button
                    as={Link}
                    to={`/product/${d.product_id}`}
                    className="new-btn-text"
                  >
                    Add to Cart
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))
      ) : (
        <p className="text-center w-100">No products available.</p>
      )}
    </>
  );
};

export default ProductsOfTheMonth;
